import { cn } from '@/lib/utils';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const proseComponents = {
  a: ({ href, children }: { href?: string; children?: React.ReactNode }) => (
    <a
      href={href}
      className="font-medium underline underline-offset-2"
      target="_blank"
      rel="noreferrer noopener"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </a>
  ),
  table: ({ children }: { children?: React.ReactNode }) => (
    <div className="overflow-x-auto">
      <table>{children}</table>
    </div>
  ),
  img: () => null,
};

/**
 * The one renderer for prose that is markdown by field contract - Content.description,
 * Recording.transcript. Deliberately conservative: a card body is not a page, so
 * headings stay close to body size and images are dropped rather than blown out.
 *
 * remarkBreaks is load-bearing, not decoration. These fields are edited in a plain
 * textarea, so a member pressing Enter once means a line break; stock markdown would
 * swallow it and the display would disagree with the editor they just typed in.
 */
export function ProseMarkdown({ text, className }: { text: string; className?: string }) {
  return (
    <Markdown
      className={cn(
        'prose prose-sm max-w-none break-words text-foreground leading-relaxed',
        'prose-headings:text-sm prose-headings:font-medium prose-headings:mt-3 prose-headings:mb-1',
        '[&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_a]:text-primary',
        className
      )}
      remarkPlugins={[remarkGfm, remarkBreaks]}
      components={proseComponents}
    >
      {text}
    </Markdown>
  );
}
